"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCachedEligibilityResults = exports.isReceivableResponseTape = exports.isArtifactDependencyRecord = exports.typeguardFunctionLogWrapper = exports.typeguardFunctionWrapper = exports.reporting = exports.portfolioGeneratedLoanTape = exports.porfolioCovenant = exports.organization = exports.materializedView = exports.loanProduct = exports.insights = exports.deliverables = exports.date = exports.datalake = exports.creditAgreement = exports.datetime = exports.assetVerification = exports.assignment = void 0;
const jsonschema_1 = __importDefault(require("jsonschema"));
const schema = __importStar(require("../schema"));
const Log_1 = require("../types/Log");
exports.assignment = __importStar(require("./assignment"));
exports.assetVerification = __importStar(require("./assetVerification"));
exports.datetime = __importStar(require("./datetime"));
exports.creditAgreement = __importStar(require("./creditAgreement"));
exports.datalake = __importStar(require("./datalake"));
exports.date = __importStar(require("./date"));
exports.deliverables = __importStar(require("./deliverables"));
exports.insights = __importStar(require("./insights"));
exports.loanProduct = __importStar(require("./loanProduct"));
exports.materializedView = __importStar(require("./materializedView"));
exports.organization = __importStar(require("./organization"));
exports.porfolioCovenant = __importStar(require("./portfolioCovenant"));
exports.portfolioGeneratedLoanTape = __importStar(require("./portfolioGeneratedLoanTape"));
exports.reporting = __importStar(require("./reporting"));
__exportStar(require("./util"), exports);
var typeguardUtils_1 = require("./typeguardUtils");
Object.defineProperty(exports, "typeguardFunctionWrapper", { enumerable: true, get: function () { return typeguardUtils_1.typeguardFunctionWrapper; } });
Object.defineProperty(exports, "typeguardFunctionLogWrapper", { enumerable: true, get: function () { return typeguardUtils_1.typeguardFunctionLogWrapper; } });
const isArtifactDependencyRecord = (obj) => {
    const { created_at: _unusedCreatedAt, updated_at: _unusedUpdatedAt } = obj, remainingObj = __rest(obj, ["created_at", "updated_at"]);
    const result = jsonschema_1.default.validate(remainingObj, schema.ArtifactDependencyRecordSchema);
    return result.valid;
};
exports.isArtifactDependencyRecord = isArtifactDependencyRecord;
const isReceivableResponseTape = (obj, logOptions) => {
    const result = jsonschema_1.default.validate(obj, schema.ReceivableResponseTapeSchema, {
        nestedErrors: true,
    });
    if ((logOptions === null || logOptions === void 0 ? void 0 : logOptions.logger) && result.errors.length > 0) {
        const error = {
            message: `Receivable Response Tape validation failed`,
            metadata: {
                logMeta: {
                    typeguard: 'isReceivableResponseTape',
                    validationErrors: result.errors.map((_error) => _error.stack),
                },
            },
        };
        logOptions.logger(error, logOptions.logLevel || Log_1.LogLevel.Error);
    }
    return result.valid;
};
exports.isReceivableResponseTape = isReceivableResponseTape;
const isCachedEligibilityResults = (obj, logOptions) => {
    const result = jsonschema_1.default.validate(obj, schema.ReceivableResponseTapePreviewEligibilityStatusesSchema, {
        nestedErrors: true,
    });
    if ((logOptions === null || logOptions === void 0 ? void 0 : logOptions.logger) && result.errors.length > 0) {
        const error = {
            message: `Receivable Response Tape Eligibility Statuses validation failed`,
            metadata: {
                logMeta: {
                    typeguard: 'isCachedEligibilityResults',
                    validationErrors: result.errors.map((_error) => _error.stack),
                },
            },
        };
        logOptions.logger(error, logOptions.logLevel || Log_1.LogLevel.Error);
    }
    return result.valid;
};
exports.isCachedEligibilityResults = isCachedEligibilityResults;
//# sourceMappingURL=index.js.map